module.exports = __webpack_public_path__ + "6a5db510.png";